export const ROOT = 'common/access';

export const FETCH_ACCESS_REQUEST = `${ROOT}/FETCH_ACCESS_REQUEST`;
export const FETCH_ACCESS_FAILURE = `${ROOT}/FETCH_ACCESS_FAILURE`;
export const FETCH_ACCESS_SUCCESS = `${ROOT}/FETCH_ACCESS_SUCCESS`;

export const CLEAR_ACCESS_DATA = `${ROOT}/CLEAR_ACCESS_DATA`;